import React, { useState, useEffect } from "react"
import { useLocation } from "@reach/router"
import dateFormat from 'dateformat';

import { Form, Row } from "react-bootstrap"

import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import RadioboxField from './elements/radio'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import './assets/styles/_index.scss'
import { postFormData, api_form_error } from "./api/Api"
import { FormsSubject } from "../../common/form-mail-subjects"
import { PageLinks } from "../../common/page-links";
import { phoneNumberValidation, Rent_Mail_Function_BVStudents, getUrlParams } from "../../common/utils/site_utlis"
import { OfficeList } from "../../common/queries/common_use_query"
import { getUser } from "@starberry/myaccount-website-utils"

import Step_1 from "./RentStudentHomeStep/step_1"
import Step_2 from "./RentStudentHomeStep/step_2"
import Step_3 from "./RentStudentHomeStep/step_3"

import $ from "jquery"


function Rent_Home(props) {
  const { loading, error, data } = OfficeList();

  const location = useLocation();
  const userData = getUser();

  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showerrormsg, setShowerrorMsg] = useState("");
  const [showthankyou, setThankyou] = useState(false);
  const [startDate, setStartDate] = useState();
  const [startTime, setStartTime] = useState();

  const [formvalues, setFormvalues] = useState("");

  const [step_val, setStep] = useState("step1");
  const [prev_step_val, setPrevStep] = useState("");

  const [token, setToken] = useState("");

  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectError, setSelectError] = useState(false);

  const [tenant_details, setTenantDetails] = useState(1);

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();

  var branch_list = [];

  if (data && data.offices && data.offices.length > 0) {
    data.offices.map((item, index) => {
      branch_list.push({label:item.name, value:item.name+","+item.email});
    })
  }

  var to_email_id = location?.state?.to_email_id ? location?.state?.to_email_id : props.to_email_id ? props.to_email_id : "";

  var replace_slashes = location.pathname.replace(/\//g, '');

  //console.log("location ==>", location, replace_slashes, props.title);


  var fields = ([
    {
      element: "config",
      formname: "Apply to Reant Student Home",
      form_type: "Apply to Reant Student Home",
      error_text: "Highlighted fields are required.",
      success_text: "Thank you, a member of our team will be in contact soon.",
      email_temp_user: "apply_rent_student_user",
      email_temp_admin: "apply_rent_student_admin",
      email_server_func: "rent-student-home",
      event_tracking: "rent-student-home",
      page_url: location.href,
      email_subject_user: FormsSubject.rent_student_home.user_subject,
      email_subject_admin: FormsSubject.rent_student_home.admin_subject
    },

    {
      text: '<b>Additional Information/Requests</b>',
      element: "html",
      class: "mt-2 content_r-m mb-3 heading_text"
    },
    {
      grpmd: "12",
      label: "Additional Information / Requests:",
      sub_text: "If you wish to provide any further information you feel may be relevant, or wish to request anything (e.g. works or cleaning to the property), or you wish to offer a higher rental figure than the property is advertised, please detail this below:",
      placeholder: "",
      name: "message",
      type: "text",
      element: "textarea",
      required: false,
      labelClass: "annual-txt",
      divclass: "form-wrap",
      class: "",
      rows: "4"
    },
    {
      text: '<b>Declaration</b>',
      element: "html",
      class: "mt-2 content_r-m mb-3 heading_text"
    },
    {
      text: 'In submitting this pre-tenancy application, I confirm the above information to be true and accurate. I understand that this application does not in any way guarantee acceptance and only acts so as to express my interest in the property, for the agent/landlord’s consideration. I understand that in the event my pre-tenancy application is accepted, it is done so on a subject to references and contract basis and the property will not be secured (subject to references and contract), until a holding deposit has been paid by me. I/we understand the rent payable and start date of the tenancy will be as advertised unless agreed otherwise. A acknowledge and accept the Privacy Policy, at <a href="/' + PageLinks.privacy_policy + '/">'+PageLinks.privacy_policy+'</a>',
      element: "html",
      class: "mt-0 content_r-m mb-3"
    },
    {
        text: '<b>Important Information:</b> As the person submitting this form, you will become the lead tenant. In doing so you confirm you have the agreement and permission of the other prospective tenants. This means we will liaise with you regarding the outcome of your application and going forward for any generic correspondence and queries we may have. ',
        element: "html",
        class: "mt-0 content_r-m mb-3"
    },
    {
      text: '<b>What happens next:</b><br />Once you submit your application, we’ll be in touch as soon possible. Our team will review your application and contact the landlord to let them know you wish to apply for the property. If approved, we’ll need you to pay a non-refundable holding deposit equivalent of 1 weeks’ rent, which is taken by card over the phone, so please ensure you have funds ready. If the rent is £120pppw and there are four tenants, you’ll need to be ready to pay £480.00. If you have indicated you are interested in either our No Deposit Option or Bills Inclusive, we’ll discuss this with you and let you know if either option is available on the property you have applied for. Once you have paid to secure the property, each tenant will receive a reservation receipt which sets out all the terms and conditions of the tenancy, which must be e-signed within 24 hours. I consent and accept use of my email address by the landlord, or a person acting on behalf of the landlord, in the service of notices and other documents given under or in connection with the tenancy. In submitting this pre-tenancy application, I confirm the supplied information to be true and accurate. I understand that this application does not in any way guarantee acceptance and only acts so as to express my interest in the property, for the agent/landlord’s consideration. I understand that in the event my pre-tenancy application is accepted, it is done so on a subject to references and contract basis and the property will not be secured (subject to references and contract), until a holding deposit has been paid by me. I/we understand that should any of the information provided be false, misleading or incorrect, or if I/we fail a credit check, have unsatisfactory references or withdraw the application, any holding deposit paid is non-refundable. I understand the property is taken ‘as seen’ unless otherwise requested, in writing, before a holding deposit is paid. I consent and accept use of my email address by the landlord, or a person acting on behalf of the landlord, in the service of notices and other documents given under or in connection with the tenancy. In addition I accept the Privacy Policy, available at <a href="/' + PageLinks.privacy_policy + '/">'+PageLinks.privacy_policy+'</a>',
      element: "html",
      class: "mt-0 content_r-m mb-3"
    },
    {
      grpmd: "6",
      name: "previous",
      type: "button",
      element: "button",
      value: "Previous",
      class: "btn btn-green",
      labelClass: "",
      customClass: "custom-button-wrapper mt-4 col-md-6",
      divclass: "form-wrap"
    },

    {
      grpmd: "6",
      name: "SUBMIT",
      type: "submit",
      element: "button",
      value: "Submit",
      class: "btn btn-green",
      labelClass: "",
      customClass: "custom-button-wrapper mt-4 col-md-6",
      divclass: "form-wrap"
    },
    {
      text: 'By proceeding, you agree to the terms set out in our <a href="/' + PageLinks.privacy_policy + '/">Privacy Policy.</a>',
      element: "html",
      class: "mt-3 text-center content_r-m"
    },
    {
      element: "captcha",
      class: "py-2",
      captchaRef: recaptchaRef
    }
  ])


  const handlechange = event => {
    // remove initial empty spaces

    if (event.type === "select") {
      //event.value = event.value.trimStart()

      setSelectedOptions(event);
    } else {
      if (event.target.name === "telephone") {
        var valid_phone = phoneNumberValidation(event.target.value);
        if (valid_phone) {
          event.target.value = valid_phone;
        } else {
          event.target.value = '';
        }
      } else {
        event.target.value = event.target.value.trimStart()
      }
    }

  }

  useEffect(() => {

    //console.log("token", token); 

    if (token !== '') {

      const processFromData = async () => {

        let formData = new FormData();

        formData.append('data', JSON.stringify(formvalues));
        setShowerror(false);

        

        postFormData(formData).then(async apiRes => {

          //console.log("apiRes", apiRes);

          window.grecaptcha.reset();

          if (apiRes?.success === true) {
            // tracking event
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'formSubmit',
              'formType': 'form-' + fields[0].event_tracking,
              'formId': 'form-' + fields[0].event_tracking,
              'formName': fields[0].formname,
              'formLabel': fields[0].formname
            });


            setThankyou(true);
            setTimeout(() => {
              setThankyou(false)
            }, 6000);

            await Rent_Mail_Function_BVStudents(formvalues);
            
          } else {
            setShowerror(true);
            setThankyou(false);
            setShowerrorMsg(api_form_error)
          }

          setStep("step1");

          $("#step_1")[0].reset();
          $("#step_2")[0].reset();
          //$("#step_3")[0].reset();

          setToken("");

        });

        formvalues['g-recaptcha-response'] = token;

        myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })

      }


      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    console.log("captcha verified");
    setToken(token);
  };

  const handleSubmit = event => {

    const form = event.currentTarget;

    //console.log("event =>", form);

    var form_obj_arr = Object.entries(form);

    //console.log("form_obj_arr =>", form_obj_arr.filter(item => item[1].required === true));

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      setShowerrorMsg(fields[0].error_text)

      if (selectedOptions?.value) {
        setSelectError(false);
      } else {
        setSelectError(true);
      }

      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    else {

      event.preventDefault();
      const formsdata = (event.target);

      const json = {}
      Object.keys(formsdata).map(key => {

        if (formsdata[key].type === "checkbox") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = 'yes'
          }
        } else if (formsdata[key].type === "radio") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = formsdata[key].value
          }
        } else {
          json[formsdata[key].name] = formsdata[key].value
        }

      })

      var date_time = dateFormat(startDate, "mmm dd, yyyy") + " " + dateFormat(startTime, "hh:MM TT");
      //json['name'] = json.first_name+' '+json.last_name;
      var params = getUrlParams();
      //console.log("filtered_team", params);

      //var branch_split = json.branch ? json.branch.split(',') : "";

      //json['name'] = formvalues.first_name+' '+formvalues.last_name;

      json['email_temp_user'] = fields[0].email_temp_user;
      json['email_temp_admin'] = fields[0].email_temp_admin;
      json['email_subject_user'] = fields[0].email_subject_user;
      json['email_subject_admin'] = fields[0].email_subject_admin;
      json['formname'] = fields[0].formname;
      json['g-recaptcha-response'] = token;
      json['date_time'] = date_time;

      // json['branch'] = branch_split.length > 0 ? branch_split[0] : json.branch;
      // if (branch_split.length > 0) {
      //   json['to_email_id'] = branch_split[1];
      // }



      //console.log("formdata final", json);

      let form_values_merge = {...formvalues, ...json};

      setFormvalues(form_values_merge);

      if(process.env.GATSBY_CAPTCHA_MODE === "test"){
        setToken("test");
      } else{
        recaptchaRef.current.execute();
      }

      setValidated(false);
      setSelectError(false);
      setSelectedOptions({});

      // reset form
      const form = event.target
      form.reset();
      setStartDate();
      setStartTime();

    }
  };

  useEffect(() => {
    window.scrollTo(0,0)
  },[step_val])

  const setFormvaluesFunc = (form_values) => {
    setFormvalues({...formvalues, ...form_values})
  }

  const handleBack = () => {
    setStep(prev_step_val);
    window.scrollTo(0,0)
  }

  //console.log("formvalues ==>", step_val, prev_step_val, tenant_details, formvalues);

  return (
    <div className="form rent_form">

      {showerror && <div className="alert alert-danger">
        {showerrormsg}
      </div>}
      <div ref={myRef}></div>

      {showthankyou && <div className="alert alert-success">
        {fields[0].success_text}
      </div>}

      <div className={step_val === "step1" ? "d-block" : "d-none"}>
        <Step_1 setStep={setStep} step_val={step_val} setFormvaluesFunc={setFormvaluesFunc} formvalues={formvalues} setPrevStep={setPrevStep} prev_step_val={prev_step_val} setTenantDetails={setTenantDetails} tenant_details={tenant_details} />
      </div>

      <div className={step_val === "step2" ? "d-block" : "d-none"}>
        <Step_2 setStep={setStep} step_val={step_val} setFormvaluesFunc={setFormvaluesFunc} formvalues={formvalues} setPrevStep={setPrevStep} prev_step_val={prev_step_val} setTenantDetails={setTenantDetails} tenant_details={tenant_details}/>
      </div>

      <div className={step_val === "step3" ? "d-block" : "d-none"}>
        <Step_3 setStep={setStep} step_val={step_val} setFormvaluesFunc={setFormvaluesFunc} formvalues={formvalues} setPrevStep={setPrevStep} prev_step_val={prev_step_val} setTenantDetails={setTenantDetails} tenant_details={tenant_details}/>
      </div>

      
      <div className={(tenant_details >= 3 && step_val === ("step"+(parseInt(tenant_details)+1))) ? "d-block" : "d-none"}>
        <Step_3 setStep={setStep} step_val={step_val} setFormvaluesFunc={setFormvaluesFunc} formvalues={formvalues} setPrevStep={setPrevStep} prev_step_val={prev_step_val} setTenantDetails={setTenantDetails} tenant_details={tenant_details}/>
      </div>

      <div className={step_val === "final" ? "d-block" : "d-none"}>
        <Form name={fields[0].formname} className={props.classNames} action="/" method="post" noValidate validated={validated} onSubmit={handleSubmit} autoComplete="off">

        <input type="hidden" name="form_name" value={fields[0].formname} />
        <input type="hidden" name="form_type" value={fields[0].form_type} />
        <input type="hidden" name="form_label" value={fields[0].formname} />
        <input type="hidden" name="to_email_id" value={to_email_id} />
        <input type="hidden" name="admin_email" value={"Yes"} />
        <input type="hidden" name="step_val" value={step_val} />
        <input type="hidden" name="tenant_details" value={tenant_details} />

        <input type="hidden" name="bot-field" />

        <Row className="custom-text-field-wrapper no_direction">
          {fields.map((field, index) => {
            if ("input" === field.element) {
              return (
                <InputField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  handlechange={handlechange}
                  errorMsg={field.errorMsg}
                  startDate={field.type === 'valuation_date' ? startDate : ''}
                  setStartDate={field.type === 'valuation_date' ? setStartDate : ''}
                  startTime={field.type === 'valuation_time' ? startTime : ''}
                  setStartTime={field.type === 'valuation_time' ? setStartTime : ''}
                  defaultValue={field?.defaultValue}
                />
              );
            }
            if ("select" === field.element) {
              return (
                <SelectField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  required={field.required}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  values={field.values}
                  key={`${field.element}~${index}`}
                  handlechange={handlechange}
                  componentprops={props}
                  //selectedValue={selectedOptions}
                  errorMsg={field.errorMsg}
                  isError={selectError}
                //isError= {Object.keys(selectError).length > 0 ? (selectError[field.name] ? '' : true) : ''}
                  optionWithLabel={true}
                />
              );
            }
            if ("textarea" === field.element) {
              return (
                <>

                  <TextAreaField
                    name={field.name}
                    divclass={field.divclass}
                    grpmd={field.grpmd}
                    label={field.label}
                    ref={field.ref}
                    rows={field.rows}
                    fieldClass={field.class}
                    labelClass={field.labelClass}
                    placeholder={field.placeholder}
                    required={field.required}
                    key={`${field.element}~${index}`}
                    handlechange={handlechange}
                    errorMsg={field.errorMsg}
                  />
                </>
              );
            }
            if ("checkbox" === field.element) {
              return (
                <CheckboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                />
              );
            }
            if ("radio" === field.element) {
              return (
                <RadioboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  values={field.values}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                  label={field.label}
                />
              );
            }
            if ("html" === field.element) {
              return (
                <HtmlBox
                  text={field.text}
                  fieldClass={field.class}
                  key={`${field.element}~${index}`}
                />
              );
            }
            if ("captcha" === field.element) {
              return (
                <ReCaptchaBox
                  fieldClass={field.class}
                  captRef={field.captchaRef}
                  key={`${field.element}~${index}`}
                  handleonVerify={handleonVerify}
                />
              );
            }
            if ("button" === field.element) {
              return (
                <>

                  <ButtonField
                    name={field.name}
                    fieldClass={field.class}
                    type={field.type}
                    value={field.value}
                    key={`${field.element}~${index}`}
                    grpmd={field.grpmd}
                    customClass={field.customClass}
                    handlClick={handleBack}
                  />

                </>
              );
            }
          })
          }
        </Row>
        </Form>
      </div>

    </div>
  );
}


const RentHome = (props) => (
  <Rent_Home {...props} />

)

export default RentHome